<template>
    <div class="water-safety">
        <van-nav-bar title="附近水域" :fixed="true" left-text="返回" :border="false" left-arrow @click-left="backPage" />
        <div v-if="!waterList || waterList.length<=0" class="address-content">
            <img class="address-img" src="@/assets/images/address_list.png" background-size="cover" />
            <p class="address-txt">暂无数据</p>
        </div>
        <div class="safety-option" v-for="(item,index) in waterList" :key="index">
            <p class="safety-date"></p>
            <div class="safety-content">
                <div class="safety-flex">
                    <p>当前位置</p>
                    <span>{{item.address}}</span>
                </div>
                <div class="safety-flex">
                    <p>半径范围</p>
                    <span>{{item.radius}}米</span>
                </div>
                <div class="safety-flex">
                    <p>附近水域</p>
                    <span>{{item.name}}</span>
                </div>
                <div class="safety-flex">
                    <p>最近距离</p>
                    <span>{{item.distance}}</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            waterList:[]
        }
    },
    created() {
        this.getWaterList()
    },
    mounted() {

    },
    methods:{
        /**
         * 获取水域列表
         */
        getWaterList(){
            let param = {
                ver:1,
                method:'selectCloseWaterList',
            }
            this.$http.get(this.$api.userInfo.POST_APPLET,param).then(res => {
                if (res.code === 0) {
                    this.waterList = res.data
                } else {
                    this.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/wrong.png'),
                    });
                }
            })
        },
        /**
         * 返回上一级
         */
        backPage() {
            this.$router.push('/location');
        },
    }
};
</script>
<style lang="scss" scoped>
.water-safety{
    padding: 90px 40px 0;
    .safety-option{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .safety-date{
            font-size: 30px;
            color: #666;
            margin: 30px 0;
        }
        .safety-content{
            width: 670px;
            background: #f8f8f8;
            border-radius: 10px;
            padding: 40px 20px 20px 40px;
            box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.2);
            .safety-flex{
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                >p{
                    font-size: 32px;
                    color: #666;
                    width: 150px;
                    margin-right: 20px;
                }
                >span{
                    flex: 1;
                    font-size: 24px;
                    color: #333;
                }
            }
        }
    }
    .address-content{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 300px;
        font-size: 28px;
        font-weight: 400;
        color: #999999;
    }
    .address-img{
        width: 426px;
        height: 230px;
    }
    .address-txt{
        margin-top: 50px;
    }
}
</style>
